import { render, staticRenderFns } from "./partners.vue?vue&type=template&id=8bd2f7b2&scoped=true"
import script from "./partners.vue?vue&type=script&lang=js"
export * from "./partners.vue?vue&type=script&lang=js"
import style0 from "./partners.vue?vue&type=style&index=0&id=8bd2f7b2&prod&scoped=true&lang=less"
import style1 from "./partners.vue?vue&type=style&index=1&id=8bd2f7b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd2f7b2",
  null
  
)

export default component.exports